import { configApi } from "@shared/lib/configApi";

export const DEFAULT_OG_IMAGE = `${configApi.API_PUBLIC_DOMAIN}/static/default-og-image.jpg`;